module.exports = __webpack_public_path__ + "static/img/14000074.4a00a2fa.png";